import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-369c4c2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "alert alert-danger alert-dismissible alert-outline fade show",
  role: "alert"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Not allowed", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" - Please Fill the background check process form first. ")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "alert",
  "aria-label": "Close"
}, null, -1))
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-lg-12" }
const _hoisted_8 = { class: "card" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Know Your Client (KYC)")
  ])
], -1))
const _hoisted_10 = { class: "card-body p-4" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Passport Image", -1))
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-sm-6" }
const _hoisted_14 = { class: "mb-3" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "col-sm-6" }
const _hoisted_17 = { class: "dropzone" }
const _hoisted_18 = ["src"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-file-image" })
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, "Passport Image Preview", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Selfie Image", -1))
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-sm-6" }
const _hoisted_24 = { class: "col-sm-6" }
const _hoisted_25 = { class: "dropzone" }
const _hoisted_26 = ["src"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-file-image" })
], -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, "Selfie Preview", -1))
const _hoisted_29 = { class: "d-flex justify-content-end mt-3" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = {
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" Submit KYC ")
const _hoisted_33 = {
  key: 1,
  class: "row"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "card-body p-4 text-center" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "mt-3" }, "Your KYC data is submitted.")
    ])
  ])
], -1))
const _hoisted_35 = [
  _hoisted_34
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WebCam = _resolveComponent("WebCam")!

  return (!_ctx.disable)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (_ctx.formID === 0 && _ctx.disable)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_5))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("input", {
                        class: "form-control",
                        accept: "image/*",
                        type: "file",
                        disabled: _ctx.disable,
                        onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.previewFile && _ctx.previewFile(...args)))
                      }, null, 40, _hoisted_15)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      (_ctx.official_doc)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _ctx.official_doc,
                            class: "img-fluid-kyc",
                            alt: "passport preview"
                          }, null, 8, _hoisted_18))
                        : _createCommentVNode("", true),
                      (!_ctx.official_doc)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _hoisted_19,
                            _hoisted_20
                          ], 64))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _hoisted_21,
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    (!_ctx.disableCamera)
                      ? (_openBlock(), _createBlock(_component_WebCam, {
                          key: 0,
                          onPhotoTaken: _ctx.livephoto
                        }, null, 8, ["onPhotoTaken"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      (_ctx.live_photo)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _ctx.live_photo,
                            class: "img-fluid-kyc",
                            alt: "passport preview"
                          }, null, 8, _hoisted_26))
                        : _createCommentVNode("", true),
                      (!_ctx.live_photo)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _hoisted_27,
                            _hoisted_28
                          ], 64))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submitKYC && _ctx.submitKYC(...args))),
                    type: "submit",
                    disabled: _ctx.kycBtn || _ctx.disable,
                    class: "btn btn-primary w-md"
                  }, [
                    _withDirectives(_createElementVNode("span", _hoisted_31, null, 512), [
                      [_vShow, _ctx.kycBtn]
                    ]),
                    _hoisted_32
                  ], 8, _hoisted_30)
                ])
              ])
            ])
          ])
        ])
      ], 64))
    : (_openBlock(), _createElementBlock("div", _hoisted_33, _hoisted_35))
}